module.exports = __webpack_public_path__ + "img/keyboard_Plus.3e870392.png";